import PropTypes from 'prop-types'
import { memo, useCallback, useMemo } from 'react'
import { useRootContext } from 'app/services/RootProvider/RootProvider'
import Button from 'components/core/Button/Button'
import classNames from 'lib/util/classNames'

/**
 * The `ToggleNightMode`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function ToggleNightMode (props) {
  const { className, useLabel, ...rest } = props
  const { setTheme, theme } = useRootContext()
  const classNameOutput = useMemo(() => classNames([className]), [className])
  const icon = useMemo(() => (theme === 'light' ? 'dark' : 'light'), [theme])
  const label = useMemo(() => {
    if (!useLabel) {
      return null
    }

    if (theme === 'light') {
      return 'Dark Mode'
    }

    return 'Light Mode'
  }, [theme, useLabel])

  /**
   * Handle click
   */
  const handleClick = useCallback(() => {
    setTheme(theme === 'light' ? 'dark' : 'light')
  }, [theme])

  return (
    <Button
      className={classNameOutput}
      icon={icon}
      useTooltip={true}
      title="Toggle Dark Mode"
      color="j"
      {...rest}
      onClick={handleClick}
    >
      {label}
    </Button>
  )
}

/** @type {object} */
ToggleNightMode.propTypes = {
  className: PropTypes.string,
  useLabel: PropTypes.bool
}

/** @type {object} */
ToggleNightMode.defaultProps = {
  className: '',
  useLabel: true
}

// Memoize
export default memo(ToggleNightMode)
